export enum VideoSource {
  Youtube = 'youtube',
  GCore = 'gcore',
  Google = 'googledrive',
  WNMeet = 'jitsi',
  Rutube = 'rutube',
}

export const GOOGLE_REGEXP = /https:\/\/drive\.google\.com\/file\/d\/([0-9A-Za-z_-]+)\//
export const YOUTUBE_REGEXP = /^(https?:\/\/)?((www\.)?youtube\.com\/(watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9\-_]{11})/
export const GCORE_REGEXP = /https:\/\/.+\.gvideo\..+\/videos\/([0-9A-Za-z_]+)/
export const WNMEET_REGEXP = /https:\/\/wnhub-meet\..+/
export const RUTUBE_REGEXP = /^https:\/\/rutube\.ru\/video\/(\w{32})(\/|$)/

interface getVideoSrcOptions {
  videoSource: VideoSource
  videoId?: string
  videoUrl?: string
  host?: string
}

export const VideoSourceRegexp = {
  [VideoSource.Youtube]: YOUTUBE_REGEXP,
  [VideoSource.GCore]: GCORE_REGEXP,
  [VideoSource.Google]: GOOGLE_REGEXP,
  [VideoSource.WNMeet]: WNMEET_REGEXP,
  [VideoSource.Rutube]: RUTUBE_REGEXP,
}

export function getVideoIdFromUrl(videoSource: VideoSource, videoUrl?: string) {
  if (!videoSource || !videoUrl) { return '' }

  switch (videoSource) {
  case VideoSource.Youtube: {
    const match = videoUrl.match(VideoSourceRegexp[VideoSource.Youtube])

    return (match && match[5].length === 11) ? match[5] : ''
  }
  case VideoSource.Google: {
    const match = videoUrl.match(VideoSourceRegexp[VideoSource.Google])

    return match ? match[1] : ''
  }
  case VideoSource.GCore: {
    const match = videoUrl.match(VideoSourceRegexp[VideoSource.GCore])

    return match ? match[1] : ''
  }
  case VideoSource.Rutube: {
    const match = videoUrl.match(VideoSourceRegexp[VideoSource.Rutube])

    return match ? match[1] : ''
  }

  default:
    return ''
  }
}

export function getVideoSrc({ videoSource, videoId = '', videoUrl = '', host = location.host }: getVideoSrcOptions) {
  let id = videoId

  if (videoUrl) {
    id = getVideoIdFromUrl(videoSource, videoUrl)
  }

  if (!id) {
    return ''
  }

  switch (videoSource) {
  case VideoSource.Youtube:
    return `https://www.youtube.com/embed/${id}?origin=${host}`
  case VideoSource.Google:
    return `https://drive.google.com/file/d/${id}/preview`
  case VideoSource.GCore: {
    return `https://player.gvideo.co/videos/${id}` }
  case VideoSource.Rutube:
    return `https://rutube.ru/play/embed/${id}`
  default:
    return ''
  }
}

export function getVideoPreview(videoSource: VideoSource, videoId: string) {
  switch (videoSource) {
  case VideoSource.Youtube:
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
  case VideoSource.Google:
    return `https://drive.google.com/thumbnail?authuser=0&sz=w480&id=${videoId}`
  case VideoSource.Rutube:
    return `https://rutube.ru/api/video/${videoId}/thumbnail/?redirect=1`
  case VideoSource.GCore:
    return ''
  default:
    return ''
  }
}

export function getVideoPreviewSmall(videoSource: VideoSource, videoId: string) {
  switch (videoSource) {
  case VideoSource.Youtube:
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
  default:
    return ''
  }
}
